import type {SentEvent, PaginatedSentEvents} from 'src/types/report';
import type {SentEventAction} from 'src/action-creators/sent-events';

import {emptyObject} from 'src/utils';
import {
  RECEIVE_AGENCY,
  RECEIVE_WORKFLOW,
  RECEIVE_EVENT,
  PAGINATION_LIMIT,
} from 'src/action-creators/sent-events';


export type SentEventState = {
  agency: PaginatedSentEvents;
  workflows: {
    [workflowId: string]: PaginatedSentEvents;
  };
  events: {
    [eventId: string]: PaginatedSentEvents;
  };
  sentEvents: {
    [sentEventId: string]: SentEvent;
  };
};

const initialPaginatedSentEvents = {
  page: 0,
  hasMore: true,
  sentEventIds: [],
} as const;

const initialState = {
  agency: initialPaginatedSentEvents,
  workflows: emptyObject,
  events: emptyObject,
  sentEvents: emptyObject,
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly agency: { readonly page: 0; readonly hasMore: true; readonly sentEventIds: readonly []; }; readonly workflows: $TEMPORARY$Object$freeze<Record<any, any>>; readonly events: $TEMPORARY$Object$freeze<Record<any, any>>; readonly sentEvents: $TEMPORARY$Object$freeze<...>; }' is not assignable to type 'SentEventState'.
  state: SentEventState | null | undefined = initialState,
  action: SentEventAction,
): SentEventState => {
  switch (action.type) {
    case RECEIVE_AGENCY: {
      // @ts-expect-error - TS2322 - Type '{ agency: { page: any; sentEventIds: any; hasMore: boolean; }; sentEvents: { [key: string]: MeSentEvent; }; workflows?: { [workflowId: string]: PaginatedSentEvents; } | undefined; events?: { ...; } | undefined; }' is not assignable to type 'SentEventState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        agency: reducePage(state.agency, action),
        // @ts-expect-error - TS2345 - Argument of type 'SentEventState | null' is not assignable to parameter of type 'SentEventState'.
        sentEvents: reduceSentEvents(state, action.payload.sentEvents),
      };
    }

    case RECEIVE_WORKFLOW: {
      const {payload} = action;
      const {workflowId} = payload;
      const workflow =
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        state.workflows[workflowId] || initialPaginatedSentEvents;

      // @ts-expect-error - TS2322 - Type '{ workflows: { [x: string]: PaginatedSentEvents | { page: any; sentEventIds: any; hasMore: boolean; }; }; sentEvents: { [key: string]: MeSentEvent; }; agency?: PaginatedSentEvents | undefined; events?: { ...; } | undefined; }' is not assignable to type 'SentEventState'.
      return {
        ...state,
        workflows: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.workflows,
          [workflowId]: reducePage(workflow, action),
        },
        // @ts-expect-error - TS2345 - Argument of type 'SentEventState | null' is not assignable to parameter of type 'SentEventState'.
        sentEvents: reduceSentEvents(state, payload.sentEvents),
      };
    }

    case RECEIVE_EVENT: {
      const {payload} = action;
      const {eventId} = payload;
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const event = state.events[eventId] || initialPaginatedSentEvents;

      // @ts-expect-error - TS2322 - Type '{ events: { [x: string]: PaginatedSentEvents | { page: any; sentEventIds: any; hasMore: boolean; }; }; sentEvents: { [key: string]: MeSentEvent; }; agency?: PaginatedSentEvents | undefined; workflows?: { ...; } | undefined; }' is not assignable to type 'SentEventState'.
      return {
        ...state,
        events: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.events,
          [eventId]: reducePage(event, action),
        },
        // @ts-expect-error - TS2345 - Argument of type 'SentEventState | null' is not assignable to parameter of type 'SentEventState'.
        sentEvents: reduceSentEvents(state, payload.sentEvents),
      };
    }

    // TODO (kyle): normalize SentEventWithExternals data if needed
  }

  // @ts-expect-error - TS2322 - Type 'SentEventState | null' is not assignable to type 'SentEventState'.
  return state;
};

const reduceSentEvents = (
  state: SentEventState,
  sentEvents: SentEvent[],
): {
  [key: string]: SentEvent;
} =>
  sentEvents.reduce(
    (
      sentEvents: {
        [key: string]: SentEvent;
      },
      sentEvent: SentEvent,
    ) => {
      sentEvents[sentEvent.sentEventId] = sentEvent;
      return sentEvents;
    },
    {...state.sentEvents},
  );

const reducePage = (
  state: PaginatedSentEvents,
  // @ts-expect-error - TS7031 - Binding element 'page' implicitly has an 'any' type. | TS7031 - Binding element 'sentEvents' implicitly has an 'any' type.
  {payload: {page, sentEvents}},
) => {
  // @ts-expect-error - TS7031 - Binding element 'sentEventId' implicitly has an 'any' type.
  const idsToAdd = sentEvents.map(({sentEventId}) => sentEventId);
  const sentEventIds =
    page === 0 ? idsToAdd : [...state.sentEventIds, ...idsToAdd];
  return {
    page,
    sentEventIds,
    hasMore: idsToAdd.length >= PAGINATION_LIMIT,
  };
};
